import styled from 'styled-components';

export const Wrapper = styled.div`
  width: 230px;
  min-height: 200px;
  display: flex;
  background: transparent;
  cursor: pointer;

  .divider {
    margin: 10px 0;
  }

  h2.title {
    font-style: normal;
    font-weight: 500;
    font-size: 18px;
    line-height: 150%;
    text-transform: capitalize;
    color: var(--color-text-muted);
    overflow: hidden;
    text-overflow: ellipsis;
    margin: 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .text {
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 130%;
    color: var(--color-text-subtle);
  }
`;
